textarea{padding:0 11px;border:1px solid #d9d9d9}.social-submitted .social.ng-invalid,.reactions-submitted .reaction.ng-invalid{border:red 1px solid!important;border-radius:2px}
/*# sourceMappingURL=social-history-add-edit.component-J42P7SNM.css.map */
